module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 9\"><path fill=\"currentColor\" d=\"M9 4.5 0 9V0Z\"></path></svg>"